export default __webpack_public_path__ + "static/media/menu_close.6fa2e09a.svg";